/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */
import moment from 'moment';
import Transformer from './transformer';

export default class BatchLogTransformer extends Transformer {

  static fetch(batch) {
    return {
      id: batch.id,
      batchId: batch.batch_id,
      description: batch.description,
      timestamp: moment(batch.timestamp).format('MMM DD, YYYY HH:MM'),
      userId: batch.user_id,
      userFullname: batch.user_fullname,
    };
  }

  static send(batch) {
    return {
      id: batch.id,
      batch_id: batch.batchId,
      description: batch.description,
      timestamp: batch.timestamp,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/batchLog.js